let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1jDO8")).then(() => parcelRequire('gy3s3'));